module.exports = __webpack_public_path__ + "media/images/site/school-red_mini-5e665fe9c6b04193b5255c3a4d42e872.jpg";